import './App.css';
import { useEffect, useRef } from "react";

function App() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => { });
    }
  }, []);

  return (
    <div className='background'>
      <h1>Portfolio Pini</h1>
      <video ref={videoRef} controls={false} autoPlay loop muted playsInline disablePictureInPicture disableRemotePlayback preload="auto" className='film-video'>
        <source src='./Image/Pellicule_Animation_V001.mp4' type='video/mp4' />
      </video>
      <h2 id='animateur'>Animateur 3D</h2>
      <h2 id='modeleur'>Modeleur</h2>
      <div className='competence'>
        <h2 id='competence_title'>Compétences</h2>
        <div className='competence_grid'>
          <img src='./Image/Maya.png' alt='Maya icône' className='competence_icon' />
          <img src='./Image/Blender.png' alt='Blender icône' className='competence_icon' />
          <img src='./Image/Zbrush.png' alt='Zbrush icône' className='competence_icon' />
          <img src='./Image/Houdini.png' alt='Houdini icône' className='competence_icon' />
          <img src='./Image/Adobe_Premiere_Pro.png' alt='Adobe première pro icône' className='competence_icon' />
          <img src='./Image/Adobe_After_Effect.png' alt='Adobe after effect icône' className='competence_icon' />
          <img src='./Image/Adobe_Illustrator.png' alt='Adobe illustrator icône' className='competence_icon' />
          <img src='./Image/Adobe_Photoshop.png' alt='Adobe Photoshop icône' className='competence_icon' />
        </div>
      </div>
      <div className='formation'>
        <h2>Formation</h2>
        <ul>
          <li>2020-2027: Ecole George Méliès</li>
          <li>2021-2022: Prépart</li>
          <li>2021: Bac Mathématiques/Informatique</li>
        </ul>
      </div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/p-0HjXlyhKU" title="Vidéo YouTube" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      <div className='pellicule_contact_container'>
        <img src='./Image/Pellicule_Fixe_Contact_Gris.png' alt='Pellicule contact' className='pellicule_contact' />
        <div id='lien_made_in_paese'>
          <a href='https://www.madeinpaese.corsica/'>
            <img src='./Image/Made_in_Paese.png' alt='Made in Paese lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_insta'>
          <a href='https://www.instagram.com/skypini20/'>
            <img src='./Image/Instagram.png' alt='Instagram lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_linkedin'>
          <a href='https://www.linkedin.com/in/pierre-nicolas-michelozzi-42948a334/'>
            <img src='./Image/Linkedin.png' alt='Linkedin lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_yt'>
          <a href='https://youtube.com/@pierre-nicolasmichelozzi4203?si=t2OE_-2cyau1bcqM'>
            <img src='./Image/YouTube.png' alt='Youtube lien' className='lien_pic' />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
